import React, { useEffect, useState } from 'react';
import isAuthenticated from '../../actions/isAuthenticated';
import auth from '../../services/auth';
import Loading from '../../components/Loading';
import { ErrorMessage } from '../../components/ErrorMessage';

export const withSSOProvider = <T extends { isSSOUser: boolean }>(WrappedComponent: React.ComponentType<T>) => {
    return (props: Omit<T, 'isSSOUser'>) => {
        const [isLoading, setLoading] = useState(true);
        const [isSSOUser, setIsSSOUser] = useState(false);
        const [error, setError] = useState('');

        useEffect(() => {
            (async () => {
                try {
                    await isAuthenticated();
                    const res = await auth.getUserInfo();
                    if (res.data?.externalProvider) {
                        setIsSSOUser(true);
                    }
                } catch (e) {
                    setError(e.message);
                } finally {
                    setLoading(false);
                }
            })();
        }, []);

        if (isLoading) {
            return <Loading />;
        }
        if (error) {
            return <ErrorMessage isDirty={true} i18nKey={'UNKNOWN'} />;
        }

        return <WrappedComponent {...(props as any)} isSSOUser={isSSOUser} />;
    };
};
